import PropTypes from "prop-types";
import React from "react";
import { CLink } from "@appcues/component-library";
import BaseModal from "components/ModalContainer/BaseModal";
import { numberWithCommas } from "utils/textFormatting";
import { BILLING_INTERVALS } from "constants/plans";
import { SUPPORT_EMAIL } from "constants/externalAppcuesResources";

import "components/ModalContainer/ConfirmAnnualPlanModal/style.scss";

const ConfirmAnnualPlanModal = props => {
  const {
    plan,
    price,
    monthlyPrice,
    interval,
    planLimit,
    beginStripePurchase
  } = props;
  const billingInterval = BILLING_INTERVALS[interval];
  const savings = numberWithCommas(
    (monthlyPrice - price) * BILLING_INTERVALS.yearly.multiplier
  );

  return (
    <BaseModal
      title={`Confirm Your Plan`}
      okText="Confirm"
      modalClass="confirm-modal"
      onClickOK={beginStripePurchase}
      {...props}
    >
      <div className="note">
        Note: Accounts that exceed their MAU limit will be upgraded for the next
        billing period. Any questions?&nbsp;
        <CLink href={`mailto:${SUPPORT_EMAIL}`} isExternal>
          Contact us
        </CLink>
        .
      </div>
      <hr />
      <div className="plan-table">
        <div>
          <div>Plan</div>
          <div>
            <strong>{plan.name}</strong> (up to {numberWithCommas(planLimit)}{" "}
            MAUs)
          </div>
        </div>
        <div>
          <div>Term</div>
          <div>
            <strong>{billingInterval.displayName}</strong>
          </div>
        </div>
        <div>
          <div>Price</div>
          <div>${price}/month</div>
        </div>
        <div>
          <div>Due now</div>
          <div>
            <strong>{`$${numberWithCommas(
              price * billingInterval.multiplier
            )} `}</strong>
            + Applicable Sales Tax
            {interval === BILLING_INTERVALS.yearly.name &&
              `\n(Annual savings of $${savings} compared to monthly plan)`}
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

ConfirmAnnualPlanModal.propTypes = {
  beginStripePurchase: PropTypes.func.isRequired,
  interval: PropTypes.string,
  plan: PropTypes.object,
  price: PropTypes.number,
  planLimit: PropTypes.string
};

export default ConfirmAnnualPlanModal;
